import React, { useEffect, useRef } from "react";
import SockJS from "sockjs-client";
import { Client } from "@stomp/stompjs";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { SIGNOUT_USER_SUCCESS } from "../Redux/constants/AuthConstant";

const BaseURL = process.env.REACT_APP_API_PATH;

function WebSocketLogoutSockJS() {
  const { userResult } = useSelector((state) => state.Auth);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const stompClientRef = useRef(null);
  const subscribedRef = useRef(false);

  const handleLogout = async () => {
    try {
      const role = userResult?.usertype?.toUpperCase();
      if (role === "ADMIN") {
        console.log("Redirecting to Admin Login");
        navigate("/admin-login");
      } else {
        navigate("/");           
      }

      setTimeout(() => {
        localStorage.clear();
        dispatch({
          type: SIGNOUT_USER_SUCCESS,
          payload: {},
          isSigninIn: false,
          msg: "Logout successfully",
        });
      }, 300);

    } catch (error) {
      console.error("Logout error:", error);
    }
  };

  // ---------------------------------------
  // WebSocket Connect + Subscribe
  // ---------------------------------------

  useEffect(() => {
    if (!userResult) return;

    const role = userResult?.usertype?.toUpperCase();
    let userId =
      role === "CANDIDATE"
        ? userResult?.userid
        : role === "VENDOR"
        ? userResult?.vendorid
        : role === "ADMIN"
        ? userResult?.adminid
        : null;

    if (!role || !userId) return;

    userId = parseInt(userId);
    if (subscribedRef.current) return;

    const stompClient = new Client({
      webSocketFactory: () => new SockJS(`${BaseURL}/ws`),
      reconnectDelay: 4000,
    });

    stompClient.onConnect = () => {
      console.log("WebSocket connected for", role, userId);

      const topic = `/topic/logout/${role}/${userId}`;
      console.log("Subscribing to", topic);

      stompClient.subscribe(topic, (msg) => {
        console.log("Received logout signal:", msg.body);
        handleLogout();
      });

      subscribedRef.current = true;
    };

    stompClient.onStompError = (frame) => {
      console.error("WebSocket STOMP error:", frame.headers["message"]);
    };

    stompClient.activate();
    stompClientRef.current = stompClient;

    return () => {
      if (stompClientRef.current) {
        stompClientRef.current.deactivate();
        stompClientRef.current = null;
      }
      subscribedRef.current = false;
    };
  }, [userResult]);

  return null; 
}

export default WebSocketLogoutSockJS;
